import axios from 'axios';

export const submitContactUs = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/contact-us`, object);

export const submitPartnerAppApplication = (object) =>
  axios.post(
    `${getGlobalRootUrl()}/sales-site/partner-app-application`,
    object
  );

export const submitPartnerContactUs = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/partner-contact-us`, object);

export const submitPartnerDesignApplication = (object) =>
  axios.post(
    `${getGlobalRootUrl()}/sales-site/partner-designer-application`,
    object
  );

export const submitBookYourDemo = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/book-a-demo`, object);

export const submitOnDemandDemoWinery = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/on-demand-demo/winery`, object);

export const submitOnDemandDemoPartner = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/on-demand-demo/partner`, object);

export const submitPartnerWithUs = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/partner-with-us`, object);

export const submitSignup = (object) => {
  if (process.env.NODE_ENV === 'frontend') {
    return Promise.resolve();
  }
  return axios.post(`${getGlobalRootUrl()}/sales-site/signup`, object);
};

export const submitPromo = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/promo`, object);

export const submitPartnerDay = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/partner-day`, object);

export const submitLightningTalk = (object) =>
  axios.post(
    `${getGlobalRootUrl()}/sales-site/partner-day-lightning-talk`,
    object
  );

export const submitCommerce7Live = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/commerce7-live`, object);

export const submitSubscribe = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/subscribe`, object);

export const submitLandingPage = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/landing-page`, object);

export const submitScholarship = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/scholarship`, object);

/*


export const submitWebinarForm = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/webinar`, object);

export const submitPartnerDay = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/partner-day`, object);

export const submitMixerForm = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/mixer`, object);

export const submitDataBook = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/data-book`, object);



export const submitEnterprisePricing = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/enterprise-pricing`, object);

export const submitAgreementForm = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/agreement`, object);

export const submitSignupTrial = (object) => {
  if (process.env.NODE_ENV === 'frontend') {
    return Promise.resolve();
  }
  return axios.post(`${getGlobalRootUrl()}/sales-site/signup/trial`, object);
};

export const submitTalkToUs = (object) =>
  axios.post(`${getGlobalRootUrl()}/sales-site/talk-to-us`, object);
  */

export const formatApiError = (apiResponse) => {
  let output = '';
  if (
    apiResponse.response &&
    apiResponse.response.data &&
    apiResponse.response.data.errors
  ) {
    output = apiResponse.response.data.errors.reduce((string, err) => {
      let newString = string;
      newString += `The field: "${err.field}" errored because "${err.message}" .`;
      return newString;
    }, '');
    output = `Error from server: ${apiResponse.response.data.message}. ${output}`;
  } else if (
    apiResponse.response &&
    apiResponse.response.data &&
    apiResponse.response.data.message
  ) {
    output = `Error from server: ${apiResponse.response.data.message}. ${output}`;
  } else if (apiResponse.message === 'Network Error') {
    output =
      'Network error.  Either internet connection is unavailable or the remote server is unavailable';
  } else {
    output = 'Error from server: Something went wrong';
  }
  return output;
};

const getGlobalRootUrl = () => {
  switch (process.env.NODE_ENV) {
    case 'production':
      return 'https://global-api.commerce7.com/v1';
    case 'frontend':
      return 'https://global-api.commerce7.com/v1';
    default:
      return 'http://localhost:3001/v1';
  }
};
